<template>
    <main-layout>
        <div class="container has-text-dark">
            <div class="is-size-3"><b>Trial</b></div>
            <div v-show="!assigned" class="top20">
                <div>To begin your 14 day trial trial of the sllink <b>"{{item.tgtSlink}}"</b> please provide the URL you would like us to redirect it to.</div>
                <div>You can then promote your slinks as <b>slink.com/{{item.tgtSlink}}</b></div>
                <div class="top20"> Enter URL:</div>
                <input class="input has-background-dBlue" type="text" v-model="url"/><br>
                <button class="button is-warning">GO</button>
            </div>

            <div class="top20">
               <div v-show="assigned" class="is-size-4">
                    Great! Your slink is ready to go!<br>
                    -->Provide ideas of how to use It<br>
                    If you want to change the URL to which your slink points to for free during the trial, please register for an account with the same email you used for this trial.<br>
                    <button class="button is-warning">REGISTER NOW</button>
               </div>
            </div>
        </div>
    </main-layout>
</template>

<script>
import MainLayout from '../layouts/Main.vue'
import { AZEventBus } from '../components/AZEventBus'

export default {
    components: {MainLayout},
    data: function(){
        return {
            inited: false,
            item: {tgtSlink: ''},
            assigned: false,
            url: ''
        }
    },

    mounted: function(){

        var self = this

        if(!this.$route.query.t.length){
            this.$router.push('/')
        }


          var self = this
        function w(d){
            if(d.Item){
                self.item = d.Item
            } else {
                self.$root.showModalOK({message: 'This link has expired or is unavailable. Please select a word to begin a new trial.'})
                self.$router.push('/')
            }
        }

        function n(){

        }
        function init(){
            // TODO wire this into API
            self.inited = true
            self.$root.apiClient.get('api/account/gettrial/' + self.$route.query.t, {}, w, n)
        }

        if(self.$root.doneFederating){
            init();
        }

        AZEventBus.$once('onFederate', msg => {
            if(self.inited == false)
                init();
        });

    },

    methods: {
        register: function(){

        },

        doAssign: function(){

            if(this.url.substring(0, 17) == "http://slink.com/" 
                || this.url.substring(0, 17) == "http://slink.com/" 
                || this.url.substring(0, 18) == "https://slink.com/" 
                || this.url.substring(0, 10) == "slink.com/" 
                || this.url.substring(0, 9) == "slink.com"
                || this.url.split('slink.com').length > 1){
                this.$root.showModalOK({message: 'You may not redirect to another slink'});
                
                return
            }

            var urlArr = this.url.split('://')

            if(urlArr.length == 1){
                if(this.url.split(':').length < 2){

                    if(this.url != ''){
                        this.url = 'http://' + this.url
                        var dotUrl = this.newUrl.split('.')
                        if(dotUrl.length < 2 && this.url != 'http://'){
                            this.$root.showModalOK({message: 'You must provide a valid URL'})
                           
                            return
                        }
                    }
                    
                } 
            } 

            var self = this;
            function w(){

            }
            function n(){

            }
            this.$root.apiClient.post('api/trialurl', {guid: this.item.guid, url: this.url})
        }
    }

}


</script>


// WEBPACK FOOTER //
// src/pages/Trial.vue